import { AUDIT_STATUS } from "./audit-status.js";

/**
 * Mapeamento entre abas da UI e parâmetro de status na API de listagem,
 * e resposta normalizada da API → id de aba.
 */
export const AUDIT_LIST_QUERY_STATUS = Object.freeze({
  tabToApiValue: Object.freeze({
    [AUDIT_STATUS.PENDING]: "pendente",
    [AUDIT_STATUS.APPROVED]: "aprovado",
    [AUDIT_STATUS.REJECTED]: "reprovado",
  }),
  normalizedApiToTab: Object.freeze({
    PENDING: AUDIT_STATUS.PENDING,
    APPROVED: AUDIT_STATUS.APPROVED,
    REJECTED: AUDIT_STATUS.REJECTED,
  }),
});

/** Valores aceitos pelo backend no query param `status` */
const AUDIT_LIST_API_STATUS = new Set(["pendente", "aprovado", "reprovado"]);

/**
 * Converte id de aba da UI ou sinónimos (inglês / caixa) no valor exigido pela API (`pendente` | `aprovado` | `reprovado`).
 * @param {unknown} tabId — ex.: {@link AUDIT_STATUS.PENDING}, `"pending"`, `"Pendente"`, `"aprovado"`
 * @returns {"pendente"|"aprovado"|"reprovado"}
 */
export function resolveAuditListQueryStatusParam(tabId) {
  const fromTab = AUDIT_LIST_QUERY_STATUS.tabToApiValue[tabId];
  if (fromTab && AUDIT_LIST_API_STATUS.has(fromTab)) {
    return fromTab;
  }
  const k = String(tabId ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (k === "pendente" || k === "pending") return "pendente";
  if (k === "aprovado" || k === "approved") return "aprovado";
  if (k === "reprovado" || k === "rejected" || k === "recusado" || k === "recusada") {
    return "reprovado";
  }
  return AUDIT_LIST_QUERY_STATUS.tabToApiValue[AUDIT_STATUS.PENDING];
}

